import request from '~/utils/request';
import AppError from '~/utils/error-handler';
import {data} from '~/dummy-data';
import rootStore from '~/redux/root-store';
import rootReducer from '~/redux/root-reducer';

export default {
  apiServices: [{name: 'admin', axios: request, isDefault: true, isSnakeCase: true}],
  errorHandler: AppError,
  dummyData: data,
  rootStore: rootStore,
  rootReducer: rootReducer,
};
